module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "m404"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10rem"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/404.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "color": "#848D99",
      "font-size": "30px",
      "font-weight": "bold",
      "font-family": "SimHei"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('app_norightview')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bth')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a875c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 1079
// module chunks = 0